'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const DateIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="DateIcon">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2 3.45203H23V22.6259H2V3.45203Z"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.56519 1.62598V6.19119"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.4348 1.62598V6.19119"
          stroke="#3D517B"
          strokeOpacity="0.56"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M2 8.01733H23" stroke="#3D517B" strokeOpacity="0.56" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </SvgIcon>
  )
}

DateIcon.propTypes = {
  sx: PropTypes.object
}
